import { ChartBar, Package, Truck } from "@/components/icons";
import { Link } from "@tanstack/react-router";

const EXPLORE_LINKS = [
  {
    title: "ລາຍງານ",
    description: "ຍອດຂາຍ · ກຳໄລ · ລູກຄ້າ · ຂົນສົ່ງ",
    href: "/app/reports",
    icon: ChartBar,
    accentClass: "bg-primary/20 text-secondary",
  },
  {
    title: "ສະຕັອກ",
    description: "lot · ສັ່ງນຳເຂົ້າ · ວາງແຜນສັ່ງເພີ່ມ",
    href: "/app/inventory",
    icon: Package,
    accentClass: "bg-secondary/20 text-secondary",
  },
  {
    title: "ຈັດສົ່ງ",
    description: "ແພັກ · ພ້ອມສົ່ງ · ຕິດຕາມຂົນສົ່ງ",
    href: "/app/fulfillment",
    icon: Truck,
    accentClass: "bg-accent/30 text-foreground",
  },
] as const;

export function DashboardExploreLinks() {
  return (
    <section className="flex flex-col gap-3">
      <div>
        <h2 className="font-display text-lg">ເຂົ້າເມນູລາຍລະອຽດ</h2>
        <p className="text-muted-foreground text-sm">
          ເບິ່ງຂໍ້ມູນເຊິງລຶກໃນແຕ່ລະພາກສ່ວນ
        </p>
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        {EXPLORE_LINKS.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className="brand-card flex items-center gap-3 p-4 transition-colors hover:bg-muted/40"
          >
            <div
              className={`flex size-10 shrink-0 items-center justify-center rounded-xl ${item.accentClass}`}
            >
              <item.icon />
            </div>
            <div className="min-w-0">
              <p className="font-medium text-sm">{item.title}</p>
              <p className="text-muted-foreground text-xs">{item.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
